var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPenIcon = function SvgPenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16h1.425L13.2 6.225 11.775 4.8 2 14.575V16Zm-1 2a.967.967 0 0 1-.713-.288A.968.968 0 0 1 0 17v-2.425a1.975 1.975 0 0 1 .575-1.4L13.2.575c.2-.183.42-.325.663-.425.241-.1.495-.15.762-.15s.525.05.775.15c.25.1.467.25.65.45L17.425 2c.2.183.346.4.438.65a2.165 2.165 0 0 1 0 1.512 1.874 1.874 0 0 1-.438.663l-12.6 12.6a1.975 1.975 0 0 1-1.4.575H1ZM12.475 5.525l-.7-.725L13.2 6.225l-.725-.7Z",
    fill: "#2C112D"
  })));
};
export default SvgPenIcon;